module.exports = __webpack_public_path__ + "media/images/favicons/152x152-ab9c5efa295e277520c11a8ffeaf5fcd.png";